import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJiraComponent } from './simple-icons-jira.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJiraComponent ],
    exports:      [ SimpleIconsJiraComponent ],
    bootstrap:    []
})
export class SimpleIconsJiraModule {}
